import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import UsageInstructions from './UsageInstructions';
import CameraCapture from './CameraCapture';
import ImageSlider from './ImageSlider';

const UnileverRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="usage-instructions" element={<UsageInstructions />} />
            <Route path="camera-capture" element={<CameraCapture />} />
            <Route path="result" element={<ImageSlider />} />
        </Routes>
    );
};

export default UnileverRoutes;